const getSearchResultCol = ({ search_type, searchResultCard }) => {

  const html = `
    <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-12">
      ${searchResultCard}
    </div>
  `;
  return html;

}

const getSearchResultCard = ({ search_type, data }) => {

  return;
  const html = `
  <div class="h-100 cursor-pointer rounded-4 border-0 shadow mouse-over-effect card">
    <div class="d-flex flex-column gap-1 card-body">
      <div class="fw-bold">${data.site_name}</div>
      <div class="d-flex flex-column">
        <div class="text-muted tiny">Successful Tender Price</div>
        <div class="">${data.success_tender_price}</div>
      </div>
    </div>
  </div>
  `;
  return html;


}

const getSearchResultMapFeatureProps = ({ data }) => {

  let positions = [];
  try {
    const geojson = JSON.parse(data.geojson);
    // positions = geojson.coordinates[0];
    positions = geojson.coordinates[0].map(item => item.slice().reverse());
  }
  catch (e) {
    //
  }

  let pathOptions = {};
  switch (data.site_status) {
    case "Upcoming":
      pathOptions = {
        color: "var(--site-status-upcoming-color)"
      }
      break;
    case "Tender Closed":
    case "Awarded":
      pathOptions = {
        color: "var(--site-status-closed-color)"
      }
      break;
    case "Open for Tender":
    case "Available for Application":
      pathOptions = {
        color: "var(--site-status-available-color)"
      }
      break;
    case "Completed":
    default:
      pathOptions = {
        color: "var(--site-status-completed-color)"
      }
      break;
  }

  return {
    type: 'polygon',
    pathOptions,
    positions,
  }

}

const getSearchResultColProps = ({ data }) => {

  return {
    xl: 3,
    lg: 4,
    md: 4,
    sm: 6,
    xs: 12,
  }

}

const getSearchResultCardProps = ({ data, search_type }) => {

  switch (search_type) {
    case "map": {
      const onClick = () => {
        // window.open(data.link, '_blank');
      }
      return {
        className: "cursor-pointer",
        onClick: onClick,
      }
    }
    default:
      const onClick = () => {
        // window.location.href = data.link;
      }
      return {
        className: "h-100 cursor-pointer rounded-4 border-0 shadow",
        onClick: onClick,
      }
      break;
  }

}

export {
  getSearchResultCol, getSearchResultCard,
  getSearchResultColProps, getSearchResultCardProps, getSearchResultMapFeatureProps
};
